/**
 * 包含n个mutation的type名称常量
 */

export const SET_USER_NAME = 'set_user_name'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js